<h1 mat-dialog-title>Importing...</h1>
<mat-dialog-content>
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</mat-dialog-content>
